import API from '../api'
import postUrl from './paths'

export const createContent = (content) =>
	new Promise((resolve, reject) => {
		API.post(postUrl.createContent, { ...content })
			.then((response) => {
				resolve(response)
			})
			.catch((err) => {
				reject(err)
			})
	})

export const contentUploadFile = (file, contentId = null, type = 'BLOG') =>
	// NEWS, BLOG, MEDIA_COVERAGE
	new Promise((resolve, reject) => {
		const formData = new FormData()
		formData.append('file', file)
		API.post(postUrl.contentUploadFile, formData, { contentId, type })
			.then((response) => {
				resolve(response.data)
			})
			.catch((err) => reject(err))
	})

// contentId is optional; skipped when uploading for content not yet created
export const uploadMagazinePdf = (file, contentId = null, type = 'MAGAZINE') =>
	new Promise((resolve, reject) => {
		const formData = new FormData()
		formData.append('file', file)
		API.post(postUrl.uploadMagazinePdf, formData, { contentId, type })
			.then((response) => {
				resolve(response.data)
			})
			.catch((err) => reject(err))
	})
